import { render, staticRenderFns } from "./driver-contact-info-display.vue?vue&type=template&id=2968438a&scoped=true&"
import script from "./driver-contact-info-display.vue?vue&type=script&lang=js&"
export * from "./driver-contact-info-display.vue?vue&type=script&lang=js&"
import style0 from "./driver-contact-info-display.vue?vue&type=style&index=0&id=2968438a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968438a",
  null
  
)

export default component.exports